import { render } from "./PageOzellikTanimlari.vue?vue&type=template&id=6c15f1d6&scoped=true"
import script from "./PageOzellikTanimlari.vue?vue&type=script&lang=js"
export * from "./PageOzellikTanimlari.vue?vue&type=script&lang=js"

import "./PageOzellikTanimlari.vue?vue&type=style&index=0&id=6c15f1d6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6c15f1d6"

export default script